<template>
  <div>
    <section id="about" class="secciones seccion-blanca formulario">
      <div class="container">
        <h1><strong>Libro de Reclamaciones</strong></h1>
        <br />

        <h4>Identificación del proveedor</h4>
        <div class="tarjeta-proveedor">
          <div class="row">
            <div class="col-sm-6">
              <img src="../assets/logo-iff.png" />
            </div>
            <div class="col-sm-6">
              <label>{{ configData.general.companyName }}</label>
              <label>RUC: {{ configData.general.companyId }}</label>
              <label>{{ configData.general.companyGeneralAddress }}</label>
            </div>
          </div>
          <div class="fecha">
            <b>LIBRO DE RECLAMACIONES</b>
            <label>Fecha: {{ today }}</label>
          </div>
        </div>

        <br />
        <br />

        <form data-toggle="validator" role="form" action="" @submit.prevent="registrar_consulta">
          <div class="row">
            <div class="col-sm-12">
              <div class="row">
                <div class="col-sm-6">
                  <h4>Identificación del consumidor reclamante</h4>
                  <br />

                  <div class="form-group">
                    <span class="ico-form ico-form-nombre"
                      ><input
                        type="text"
                        class="form-control ico-form-space"
                        v-model="client_name"
                        placeholder="Nombre Completo *"
                        required
                        pattern=".*[^ ].*"
                        title="Ingrese su nombre completo."
                        maxlength="400"
                    /></span>
                  </div>

                  <div class="form-group">
                    <span class="ico-form ico-form-email"
                      ><input
                        type="text"
                        class="form-control ico-form-space"
                        v-model="client_home"
                        placeholder="Domicilio *"
                        required
                        pattern=".*[^ ].*"
                        title="Ingrese su domicilio"
                        maxlength="400"
                    /></span>
                  </div>

                  <div class="form-group">
                    <span class="ico-form ico-form-nombre"
                      ><input
                        type="text"
                        class="form-control ico-form-space"
                        v-model="dni_ce"
                        placeholder="DNI/CE *"
                        required
                        title="Ingrese su documento de identidad."
                        maxlength="8"
                        pattern="[0-9]{8}"
                    /></span>
                  </div>

                  <div class="form-group">
                    <span class="ico-form ico-form-nombre"
                      ><input
                        type="text"
                        class="form-control ico-form-space"
                        v-model="client_phone"
                        placeholder="Teléfono *"
                        required
                        pattern="[0-9()+][0-9() -]+"
                        title="Ingrese su Teléfono."
                        maxlength="9"
                    /></span>
                  </div>

                  <div class="form-group">
                    <span class="ico-form ico-form-nombre"
                      ><input
                        type="email"
                        class="form-control ico-form-space"
                        v-model="email_client"
                        placeholder="Correo electrónico *"
                        required
                        title="Ingrese su correo electrónico."
                        maxlength="500"
                    /></span>
                  </div>
                </div>
                <div class="col-sm-6">
                  <h4>Identificación del bien contratado</h4>
                  <br />

                  <div class="form-group">
                    <select
                      class="form-control ico-form-space"
                      v-model="type_service"
                      id="basicSelect"
                      value="Seleccione Tipo de Bien *"
                      required
                    >
                      <option disabled value="">Seleccione Tipo de Bien *</option>
                      <option value="PRODUCTO">Producto</option>
                      <option value="SERVICIO">Servicio</option>
                    </select>
                  </div>

                  <div class="form-group">
                    <select
                      class="form-control ico-form-space"
                      v-model="store"
                      value="Seleccione una tienda *"
                      required
                    >
                      <option disabled value="">Seleccione una tienda</option>
                      <optgroup
                        v-for="t in stores"
                        :key="t.id_type_store"
                        :label="t.desc_type_store"
                      >
                        <option
                          v-for="s in t.stores"
                          :key="s.id_store"
                          :value="{
                            id: s.id_store,
                            text: s.desc_store,
                            erp_code: s.erp_code_store,
                          }"
                          >{{ s.desc_store }}</option
                        >
                      </optgroup>
                    </select>
                  </div>

                  <div class="form-group">
                    <span class="ico-form ico-form-nombre">
                      <date-picker
                        v-model="date_incident"
                        :config="options"
                        placeholder="Fecha del incidente"
                        required
                      ></date-picker>
                    </span>
                  </div>

                  <div class="form-group">
                    <span class="ico-form ico-form-nombre"
                      ><input
                        type="number"
                        min="0.00"
                        max="10000.00"
                        step="0.01"
                        class="form-control ico-form-space"
                        v-model="claim_amount"
                        placeholder="Monto Reclamado en Soles (S/) *"
                        required
                        title="Ingrese el monto reclamado en Soles (S/)."
                        maxlength="9"
                    /></span>
                  </div>

                  <div class="form-group">
                    <span class="ico-form ico-form-nombre"
                      ><input
                        type="text"
                        class="form-control ico-form-space"
                        v-model="service_description"
                        placeholder="Descripción *"
                        required
                        pattern=".*[^ ].*"
                        title="Ingrese descripción del bien."
                        maxlength="600"
                    /></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="row">
                <div class="col-sm-12">
                  <h4 style="margin-bottom: 25px;">
                    Detalle de la reclamación y pedido del consumidor
                  </h4>
                  <div class="col-xs-12 text-center">
                    <div class="leyenda">
                      <label
                        ><b>Reclamo:</b> Disconformidad relacionada a los productos o
                        servicios.</label
                      >
                      <label
                        ><b>Queja:</b> Disconformidad no relacionada a los productos o servicios; o,
                        malestar o descontento respecto a la atención al público.</label
                      >
                    </div>
                  </div>

                  <div class="form-group">
                    <select
                      class="form-control ico-form-space"
                      v-model="claim_type"
                      id="basicSelect"
                      value="Seleccione Tipo de Reclamación *"
                      required
                    >
                      <option disabled value="">Seleccione Tipo de Reclamación *</option>
                      <option value="RECLAMO">Reclamo</option>
                      <option value="QUEJA">Queja</option>
                    </select>
                  </div>

                  <div class="form-group">
                    <textarea
                      class="form-control"
                      style="height: 248px;"
                      rows="8"
                      v-model="claim_detail"
                      placeholder="Ingrese el detalle de su reclamación *"
                      maxlength="1500"
                      required
                    ></textarea>
                  </div>

                  <div class="form-group">
                    <textarea
                      class="form-control"
                      style="height: 248px;"
                      rows="8"
                      v-model="claim_request"
                      placeholder="Ingrese el detalle de su pedido *"
                      maxlength="1500"
                      required
                    ></textarea>
                  </div>

                  <div class="row">
                    <div class="col-sm-3">
                      <label class="leyenda-archivo"
                        >Si desea puede adjuntar un archivo de sustento (Word, PDF o JPG, máximo 5
                        MB)</label
                      >
                    </div>
                    <div class="col-sm-9">
                      <input
                        id="fileClaim"
                        type="file"
                        class="form-control"
                        @change="onFileChange"
                        multiple
                      />
                    </div>
                  </div>

                  <template v-if="document_data.length > 0">
                    <div class="leyenda">
                      <label
                        ><b>Archivos adjuntos: {{ document_data.length }}</b></label
                      >
                    </div>
                    <table class="table">
                      <thead>
                        <tr>
                          <th scope="col">Número</th>
                          <th scope="col">Nombre archivo</th>
                          <th scope="col">Eliminar</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(file, index) in document_data" v-bind:key="file.name">
                          <th scope="row">{{ index + 1 }}</th>
                          <td>{{ file.name }}</td>
                          <td>
                            <button
                              type="button"
                              class="btn btn-danger"
                              @click="eliminarArchivo(file)"
                            >
                              <i class="fa fa-trash"></i> Eliminar Archivo
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <br />
                  </template>
                </div>

                <div class="col-sm-12">
                  <h4>¿Eres menor de edad?</h4>
                  <br />

                  <div class="form-group">
                    <span style="display:inline">
                      <input
                        type="radio"
                        :value="true"
                        class="contact-inline"
                        v-model="under_age"
                      />
                      Si
                    </span>
                    &nbsp;
                    <span>
                      <input
                        type="radio"
                        :value="false"
                        class="contact-inline"
                        v-model="under_age"
                      />
                      No
                    </span>
                  </div>

                  <template v-if="under_age">
                    <div class="form-group">
                      <span class="ico-form ico-form-nombre"
                        ><input
                          type="text"
                          class="form-control ico-form-space"
                          v-model="parent_name"
                          placeholder="Nombre del padre/madre *"
                          required
                          pattern=".*[^ ].*"
                          title="Ingrese su nombre completo del Padre/Madre."
                          maxlength="400"
                      /></span>
                    </div>

                    <div class="form-group">
                      <span class="ico-form ico-form-email"
                        ><input
                          type="text"
                          class="form-control ico-form-space"
                          v-model="parent_dni_ce"
                          placeholder="DNI/CE *"
                          required
                          title="Ingrese el DNI/CE del padre."
                          maxlength="8"
                          pattern="[0-9]{8}"
                      /></span>
                    </div>

                    <div class="form-group">
                      <span class="ico-form ico-form-nombre"
                        ><input
                          type="text"
                          class="form-control ico-form-space"
                          v-model="parent_phone"
                          placeholder="Teléfono*"
                          required
                          pattern="[0-9()+][0-9() -]+"
                          title="Ingrese el teléfono del padre."
                          maxlength="9"
                      /></span>
                    </div>

                    <div class="form-group">
                      <span class="ico-form ico-form-nombre"
                        ><input
                          type="email"
                          class="form-control ico-form-space"
                          v-model="parent_email"
                          placeholder="Correo electrónico *"
                          required
                          title="Ingrese el correo electrónico del padre."
                          maxlength="500"
                      /></span>
                    </div>

                    <div class="form-group">
                      <span class="ico-form ico-form-nombre"
                        ><input
                          type="text"
                          class="form-control ico-form-space"
                          v-model="parent_address"
                          placeholder="Domicilio de uno de los padres o representantes del consumidor *"
                          required
                          title="Ingrese el domicilio de uno de los padres o representantes del consumidor"
                          maxlength="400"
                      /></span>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xs-12 text-center">
            <div class="mensaje-obligatorio">
              * Los campos marcados con asterisco son obligatorios.
            </div>
          </div>

          <template v-if="mensaje != ''">
            <div class="col-xs-12 text-center">
              <div :class="[mensaje === '' ? 'd-none' : 'alert alert-success']" role="alert">
                <button type="button" class="close" data-dismiss="alert" @click="ocultar()">
                  &times;</button
                ><strong>{{ mensaje }}</strong>
              </div>
            </div>
          </template>
          <template v-if="mensaje_error != ''">
            <div class="col-xs-12 text-center">
              <div :class="[mensaje_error === '' ? 'd-none' : 'alert alert-danger']" role="alert">
                <button type="button" class="close" data-dismiss="alert" @click="ocultar()">
                  &times;</button
                ><strong>{{ mensaje_error }}</strong>
              </div>
            </div>
          </template>
          <template v-if="loading_form != false">
            <div class="col-xs-12 text-center">
              <div class="progress">
                <div
                  class="progress-bar progress-bar-striped active"
                  role="progressbar"
                  aria-valuenow="100"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 100%"
                ></div>
              </div>
            </div>
          </template>
          &nbsp;

          <div class="col-xs-12 text-center  mt-2">
            <button type="submit" class="btn btn-lg btn-primary">Enviar Reclamo</button>
          </div>
        </form>

        <br />
        <br />

        <div id="modalConfirmation" class="modal" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <img src="../assets/logo-iff.png" />
                <h5 class="modal-title">
                  <label>Libro de reclamaciones</label>
                  <label><b>RUC: </b>{{ configData.general.companyId }}</label>
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <p>
                  Se registró correctamente el libro de reclamaciones.<br />
                  Número de reclamo:
                  <label style="text-decoration: underline">{{ claim_id }}</label>
                </p>

                <p>Gracias por tu comunicación, hemos recibido tus datos.</p>
              </div>
              <div class="modal-footer">
                <!-- <button type="button" class="btn btn-lg btn-primary" @click="exportPDF(urlPDF)">Descargar para imprimir</button>-->
                <a class="btn btn-lg btn-primary" :href="urlPDF" target="_blank"
                  >Descargar para imprimir</a
                >
                <button
                  type="button"
                  class="btn btn-lg btn-secondary"
                  @click="clearClaimId()"
                  data-dismiss="modal"
                >
                  Regresar
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- <template v-if="reclamo_realizado">
          <button class="btn btn-secondary" @click="exportPDF"><i class="fa fa-print"></i> Imprimir Consolidado de Reclamo</button>
        </template>  -->
      </div>
    </section>
    <GoToTrackingModule />
    <GuideModule />
  </div>
</template>

<style>
@media (min-width: 992px) {
  #about {
    padding-top: 160px;
  }
}

.modal-body p {
  font-size: 16px !important;
  margin-bottom: 0px;
}

.tarjeta-proveedor {
  padding: 25px 25px 10px 25px;
  border: solid 0.5px;
  width: 40%;
  margin: auto;
}

.tarjeta-proveedor .row {
  padding-bottom: 10px !important;
}

.tarjeta-proveedor .row label {
  display: block;
  text-align: left;
  line-height: 10px;
}

.tarjeta-proveedor .row img {
  height: 75%;
}

.tarjeta-proveedor .fecha label {
  display: block;
}

.leyenda {
  margin-bottom: 30px;
  color: #505050;
  font-size: 13px;
  text-align: left;
}

.leyenda-archivo {
  color: #191d21;
  font-size: 15px;
  text-align: left;
}

.form-control {
  border-radius: 0px !important;
  font-size: 13.5px;
  color: #191d21 !important;
}

.contact-inline {
  height: 10px !important;
}
.no-border-country {
  border-radius: 2px !important;
}

.avatar {
  border-radius: 10px;
}
.row-height2 {
  background-color: #e5e5ea;
  border-radius: 15px 15px 15px 15px;
}

.not-padding-left {
  padding-left: 0 !important;
  padding-right: 12px !important;
}
.not-padding-right {
  padding-right: 0 !important;
  padding-left: 12px !important;
}
.posicion-relativa {
  position: relative;
}
.btn-3d-celeste {
  color: rgb(43, 172, 234);
  border-color: rgb(43, 172, 234);
  background-color: transparent;
}
.btn-3d-celeste:hover,
.btn-3d-celeste:focus,
.btn-3d-celeste:active {
  color: rgba(43, 172, 234, 0.7);
}
.btn-3d {
  position: relative;
  display: inline-block;
  top: 0;
  margin-bottom: 0;
  font-weight: 700;
  font-family: 'Montserrat', sans-serif;
  text-transform: uppercase;
  border-style: solid;
  border-top-width: 1px;
  border-right-width: 1px;
  border-bottom-width: 6px;
  border-left-width: 1px;
  border-radius: 8px;
  transition: all 0.15s;
}
.btn-3d:hover {
  top: 4px;
  margin-bottom: 3px;
  border-bottom-width: 3px;
}
.btn-3d:active {
  top: 6px;
  margin-bottom: 5px;
  border-bottom-width: 1px;
}

.formulario form input,
.formulario form select,
.formulario form textarea {
  border-color: #ced4da;
}

.dropdown-menu {
  background-color: var(--primary-color) !important;
}

@media (min-width: 0px) {
  .btn-3d-md {
    padding: 12px;
    font-size: 14px;
  }
  .btn-3d-lg {
    padding: 10px 15px;
    font-size: 14px;
  }
  .not-padding-left-fields {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .not-padding-right-fields {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }

  .not-padding-left-fields-peru {
    padding-left: 0 !important;
    padding-right: 0px !important;
  }
  .not-padding-right-fields-peru {
    padding-right: 0 !important;
    padding-left: 0px !important;
  }
}
@media (min-width: 576px) {
  .btn-3d-md {
    padding: 12px;
    font-size: 14px;
  }
  .btn-3d-lg {
    padding: 10px 15px;
    font-size: 14px;
  }
  .not-padding-left-fields {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .not-padding-right-fields {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }

  .not-padding-left-fields-peru {
    padding-left: 0 !important;
    padding-right: 10px !important;
  }
  .not-padding-right-fields-peru {
    padding-right: 0 !important;
    padding-left: 0px !important;
  }
}
@media (min-width: 768px) {
  .btn-3d-md {
    padding: 12px;
    font-size: 14px;
  }
  .btn-3d-lg {
    padding: 10px 15px;
    font-size: 14px;
  }
  .not-padding-left-fields {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .not-padding-right-fields {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }

  .not-padding-left-fields-peru {
    padding-left: 0 !important;
    padding-right: 12px !important;
  }
  .not-padding-right-fields-peru {
    padding-right: 0 !important;
    padding-left: 12px !important;
  }
}
@media (min-width: 992px) {
  .btn-3d-md {
    padding: 10px 15px;
    font-size: 14px;
  }
  .btn-3d-lg {
    padding: 15px 20px;
    font-size: 15px;
  }
  .not-padding-left-fields {
    padding-left: 0 !important;
    padding-right: 12px !important;
  }
  .not-padding-right-fields {
    padding-right: 0 !important;
    padding-left: 12px !important;
  }
}
@media (min-width: 1200px) {
  .btn-3d-md {
    padding: 15px;
    font-size: 16px;
  }
  .btn-3d-lg {
    padding: 15px 25px;
    font-size: 16px;
  }
  .not-padding-left-fields {
    padding-left: 0 !important;
    padding-right: 12px !important;
  }
  .not-padding-right-fields {
    padding-right: 0 !important;
    padding-left: 12px !important;
  }
}
</style>

<script>
import { config_settings } from '../config.js';
import { errorToaster } from '../components/shared/service/ErrorHandler';
import datePicker from 'vue-bootstrap-datetimepicker';
import GoToTrackingModule from '@/modules/GoToTrackingModule.vue';
import GuideModule from '@/modules/GuideModule.vue';
import axios from 'axios';
import * as jsPDF from 'jspdf';
import _ from 'lodash';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import 'jspdf-autotable';

//HTTP ERROR STATUS
const NOT_FOUND = 404;
const BAD_REQUEST = 400;
const UNAUTHORIZED = 401;
const INTERNAL_SERVER_ERROR = 500;

axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (error.message === 'Network Error') {
      toastr.error(
        'No se puede conectar con el servidor. Verifique su conexión a internet',
        'ERROR',
        { iconClass: 'customer-danger' },
      );
    } else if (error.response.status === UNAUTHORIZED) {
      if (error.response.data.message === 'Access is denied') {
        toastr.error('Usted no tiene los provilegios para acceder a esta sección', 'ERROR', {
          iconClass: 'customer-danger',
        });
      } else {
        return Promise.reject(error);
      }
    } else {
      return Promise.reject(error);
    }
  },
);

export default {
  components: {
    datePicker,
    GoToTrackingModule,
    GuideModule,
  },
  props: ['configData'],
  data() {
    return {
      options: {
        format: 'DD/MM/YYYY',
        useCurrent: false,
        locale: 'es',
      },

      imgPreUrl: config_settings.PHOTO_SERVER_URL + '/',
      cod_sub_sec: 6,
      nom_sub_sec_es: '',
      nom_sub_sec_en: '',
      internal_name_es: '',
      internal_name_en: '',
      desc_sub_section_es: '',
      desc_sub_section_en: '',
      section: '',
      url_1st_image: 'products/empty-img',
      url_2nd_image: 'products/empty-img',
      url_3rd_image: 'products/empty-img',
      url_4th_image: 'products/empty-img',
      url_5th_image: 'products/empty-img',
      type_1st_image: 'image',
      type_2nd_image: 'image',
      type_3rd_image: 'image',
      type_4th_image: 'image',
      type_5th_image: 'image',
      text1_es: '',
      text1_en: '',
      text2_es: '',
      text2_en: '',
      text3_es: '',
      text3_en: '',
      orientation: '',
      url_es: '',
      url_en: '',
      order_sub_section: '',
      id_position_menu: '',
      url_video: '',
      type: '',
      loading_form: false,
      mensaje_error: '',
      mensaje: '',

      claim_id: '',
      client_name: '',
      client_home: '',
      dni_ce: '',
      client_phone: '',
      email_client: '',
      type_service: '',
      date_incident: '',
      claim_amount: '',
      service_description: '',
      claim_type: '',
      claim_detail: '',
      claim_request: '',
      under_age: false,
      parent_name: '',
      parent_dni_ce: '',
      parent_phone: '',
      parent_email: '',
      parent_address: '',
      fecreg: '',
      detalle_reclamo_pdf: [],
      document_data: [],

      reclamo_realizado: false,
      today: '',

      store: '',
      stores: [],
      value: [],
      urlPDF: '',
    };
  },

  methods: {
    clearClaimId() {
      this.claim_id = '';
    },

    exportPDF() {
      location.href = this.urlPDF;
    },

    registrar_consulta() {
      this.loading_form = true;
      let external_param = '';

      if (this.document_data.length > 0) {
        external_param = '?isFile=true';
      }

      if (this.parent_phone == '') {
        this.parent_phone = 0;
      }

      if (this.under_age == null) {
        this.under_age = false;
      }

      var json_data = {
        client_name: this.client_name,
        client_home: this.client_home,
        dni_ce: this.dni_ce,
        client_phone: this.client_phone,
        email_client: this.email_client,
        type_service: this.type_service,
        date_incident: this.date_incident,
        claim_amount: this.claim_amount,
        service_description: this.service_description,
        claim_type: this.claim_type,
        claim_detail: this.claim_detail,
        claim_request: this.claim_request,
        under_age: this.under_age,
        parent_name: this.parent_name,
        parent_dni_ce: this.parent_dni_ce,
        parent_phone: this.parent_phone,
        parent_email: this.parent_email,
        parent_address: this.parent_address,
        store: {
          id_store: this.store.id,
          desc_store: this.store.text,
          erp_code_store: this.store.erp_code,
        },
      };

      console.log(JSON.stringify(json_data));

      axios({
        method: 'post',
        url: config_settings.RESOURCE_SERVER_URL + '/POST/claims' + external_param,
        data: json_data,
      })
        .then((response) => {
          this.urlPDF = response.data.linkPDF;
          var texto_respuesta = response.data.details;
          var codigo = texto_respuesta.replace('The claim was created. id:', '');
          this.claim_id = codigo;

          if (this.document_data.length > 0) {
            this.uploadDocument(codigo);
            console.log('Estoy aqui');
          } else {
            //this.mensaje = "¡Su reclamo ha sido enviado exitosamente!"
            $('#modalConfirmation').modal('show');
          }

          this.mensaje_error = '';
          this.reset();
          this.loading_form = false;
          this.reclamo_realizado = true;
        })
        .catch((error) => {
          this.mensaje = '';
          this.mensaje_error =
            'Hubo un error al momento de enviar su reclamo. Inténtelo nuevamente.';
          this.reclamo_realizado = false;

          this.loading_form = false;
        });
    },

    ocultar() {
      this.mensaje = '';
      this.mensaje_error = '';
    },

    reset() {
      this.client_name = '';
      this.client_home = '';
      this.dni_ce = '';
      this.client_phone = '';
      this.email_client = '';
      this.type_service = '';
      this.claim_amount = '';
      this.service_description = '';
      this.claim_type = '';
      this.claim_detail = '';
      this.claim_request = '';
      this.under_age = null;
      this.parent_name = '';
      this.parent_address = '';
      this.parent_dni_ce = '';
      this.parent_phone = '';
      this.parent_email = '';
      this.date_incident = '';
      this.store = '';
    },

    scroll_inicio() {
      window.scrollTo(0, 0);
    },

    uploadDocument(id) {
      var form = new FormData();
      form.append('claim_id', id);

      for (let i = 0; i < this.document_data.length; i++) {
        form.append('files', this.document_data[i]);
      }

      axios({
        method: 'post',
        url: config_settings.RESOURCE_SERVER_URL + '/POST/claims/document',
        data: form,
      })
        .then((response) => {
          //this.mensaje = '¡Exito!, su documento y el reclamo se generaron con éxito.';
          this.mensaje_error = '';
          this.document_data = '';
          $('#modalConfirmation').modal('show');
        })
        .catch((error) => {
          this.mensaje = '';
          this.mensaje_error =
            'Su reclamo fue registrado correctamente en el sistema pero no se pudo subir sus archivos adjuntos al servidor. El sistema solo acepta un máximo de 3 archivos en formato .jpg y .pdf y .docx.';
          console.log(error.response.data.message);
        });
    },

    onFileChange(e) {
      let actual_size = this.document_data.length;
      const file = e.target.files;
      let files_size = file.length;

      if (actual_size < 4 && actual_size + files_size < 4) {
        const file = e.target.files;
        let fileList = [];

        for (let i = 0; i < files_size; i++) {
          const mimeType = file[i].type;
          if (
            mimeType == 'application/pdf' ||
            mimeType == 'application/msword' ||
            mimeType == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
            mimeType == 'application/vnd.google-apps.document' ||
            mimeType == 'image/jpeg'
          ) {
            fileList.push(file[i]);
          } else {
            alert(
              'No se puede subir el archivo: ' +
                file[i].name +
                '. El formato tiene que estar en .docx, .pdf o .jpg/.jpeg.',
            );

            //this.document_data = "";
            //fileList = [];
            //document.getElementById("fileClaim").value = "";
            return;
          }
        }

        //this.document_data = fileList;
        this.document_data = this.document_data.concat(fileList);
        console.log('Atención: ' + JSON.stringify(this.document_data));
      } else {
        alert('No se puede subir mas de 3 archivos adjuntos por reclamo al sistema.');
      }

      document.getElementById('fileClaim').value = '';
    },

    getStores() {
      axios({
        method: 'get',
        url: config_settings.RESOURCE_SERVER_URL + '/GET/type_store',
      })
        .then((response) => {
          this.stores = response.data;
        })
        .catch((error) => {
          this.mensaje = '';
          console.log(error.response.data.message);
        });
    },

    eliminarArchivo(file) {
      console.log(this.document_data);
      this.document_data = this.document_data.filter(function(item) {
        return item !== file;
      });
      console.log(this.document_data);
    },
  },

  created() {
    this.scroll_inicio();
    this.getStores();
    /* Fecha actual */
    const d = new Date();
    this.today = d.toLocaleDateString();
  },
};
</script>
